import React from "react";
import PropTypes from "prop-types";

function Prefix({ content }) {
  if (content) {
    return <span className="prefix">{content}</span>;
  } else {
    return null;
  }
}

Prefix.propTypes = {
  content: PropTypes.string
};

export default Prefix;
